import React from 'react';
import update from 'immutability-helper';
import {t} from 'ttag';
import {Formik, Form} from 'formik';
import CompanyName from './company-name/company-name.jsx';
import PhoneNumber from './phone-number/phone-number.jsx';
import Country from './country/country.jsx';
import Wrapper from '../../../../wrapper/wrapper.jsx';
import Line from '../../../../line/line.jsx';
import {SaveButton} from '../../../../../components/button/button';
import {useAppContext} from '../../../../../app-context.js';
import {useRequest} from '../../../../../common/hooks';
import {updateUserReq} from '../../../../../common/api/api.js';
import {trimValues} from '../../../../../common/actions.js';
import Email from './email/email';

const Profile = () => {
  const {user, setUser, setNotificationList} = useAppContext();

  const {request} = useRequest();

  const handleSubmit = async values => {
    const trimmedValues = trimValues(values);
    const res = await request(updateUserReq(user.id, trimmedValues));

    if (Object.keys(res).length) {
      setUser(
        update(user, {
          title: {$set: res.title},
          phone: {$set: res.phone},
          country: {$set: res.country},
          is_manager: {$set: res.is_manager},
          email: {$set: res.email}
        })
      );

      setNotificationList(prevValue =>
        update(prevValue, {
          $push: [
            {
              title: user.domain,
              text: t`Your account information has been updated.`
            }
          ]
        })
      );
    }

    return true;
  };

  const initialValues = {
    country: user.country || '',
    phone: user.phone || '',
    title: user.title || '',
    email: user.email
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      <Form>
        <Wrapper gap={16} isColumn>
          <CompanyName />
          <Email />
          <PhoneNumber />
          <Country />
        </Wrapper>

        <Line />
        <SaveButton>{t`Save`}</SaveButton>
      </Form>
    </Formik>
  );
};

export default Profile;
